import Image from 'app/Components/Shared/Image/image';
import React, { useState, useRef, useEffect } from 'react';
import './SearchField.scss';
import searchIcon from './Images/search.png';
import clearIcon from './Images/X.svg';
const SearchField = ({
  placeholder = 'חפשו שיר, אמן או ז\'אנר...',
  variant = 'default', // 'default' or 'hover'
  onSearch = () => {},
  onFocus = () => {},
  onBlur = () => {},
  onChange = () => {},
  className = '',
  disabled = false,
  value = '',
  autoFocus = false
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(newValue);
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur(e);
  };

  const handleSearch = () => {
    if (inputValue.trim()) {
      onSearch(inputValue.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleClear = () => {
    setInputValue('');
    onChange('');
    inputRef.current?.focus();
  };

  // Determine current variant based on props and focus state
  const currentVariant = variant === 'hover' || isFocused ? 'hover' : 'default';

  return (
    <div className={`search-field ${currentVariant} ${className} ${disabled ? 'disabled' : ''}`}>
      <div className="search-field-container">
          <div className="search-field-icon">
          <div className="search-field-icon-bg">
            <Image src={searchIcon} alt="Search" className="search-field-search-icon" />
          </div>
        </div>

        <input
          ref={inputRef}
          type="text"
          className="search-field-input"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          autoComplete="off"
          spellCheck="false"
          dir="rtl"
        />

      

        {inputValue && !disabled && (
          <button
            type="button"
            className="search-field-clear"
            onClick={handleClear}
            aria-label="נקה חיפוש"
            tabIndex={0}
          >
            <Image src={clearIcon} alt="Clear" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchField;
